import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import ComingSoon from './components/ComingSoon';

ReactDOM.render(
  <React.StrictMode>
    <ComingSoon />
  </React.StrictMode>,
  document.getElementById('root')
);
